(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hub19-promo-strip"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const preview = document.querySelector('[data-hub19-flash-preview]');
    if (preview) {
      const key = 'hub19_counter_design_preview_start';
      let started = Date.now();
      try {
        const stored = Number(localStorage.getItem(key));
        if (Number.isFinite(stored) && stored > 0 && stored <= started) started = stored;
        else localStorage.setItem(key, String(started));
      } catch (_) {}
      const hours = preview.querySelector('[data-preview-hours]');
      const mins = preview.querySelector('[data-preview-mins]');
      const secs = preview.querySelector('[data-preview-secs]');
      let interval;
      const renderPreview = () => {
        const total = Math.ceil(Math.max(0, started + 86400000 - Date.now()) / 1000);
        if (total === 0) {
          preview.hidden = true;
          if (interval) clearInterval(interval);
          return;
        }
        hours.textContent = String(Math.floor(total / 3600)).padStart(2, '0');
        mins.textContent = String(Math.floor((total % 3600) / 60)).padStart(2, '0');
        secs.textContent = String(total % 60).padStart(2, '0');
      };
      renderPreview();
      if (!preview.hidden) interval = setInterval(renderPreview, 1000);
      return;
    }
    const root = document.querySelector('[data-hub19-flash]');
    if (!root) return;
    const endpoint = root.dataset.endpoint;
    if (!endpoint || !endpoint.startsWith('/apps/')) return;
    let visitorId;
    try {
      visitorId = localStorage.getItem('hub19_welcome_visitor');
      if (!visitorId) {
        visitorId = crypto.randomUUID();
        localStorage.setItem('hub19_welcome_visitor', visitorId);
      }
    } catch (_) { visitorId = crypto.randomUUID(); }
    const url = new URL(endpoint, location.origin);
    url.searchParams.set('vid', visitorId);
    fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then((response) => response.ok ? response.json() : null)
      .then((offer) => {
        if (!offer || offer.eligible !== true || typeof offer.code !== 'string' || !/^[A-Z0-9_-]{4,40}$/i.test(offer.code)) return;
        const expiresAt = Date.parse(offer.expiresAt);
        const serverTime = Date.parse(offer.serverTime);
        if (!Number.isFinite(expiresAt) || !Number.isFinite(serverTime) || expiresAt <= serverTime || expiresAt - serverTime > 86460000) return;
        const code = root.querySelector('[data-hub19-code]');
        const hours = root.querySelector('[data-hub19-hours]');
        const mins = root.querySelector('[data-hub19-mins]');
        const secs = root.querySelector('[data-hub19-secs]');
        const apply = root.querySelector('[data-hub19-apply]');
        if (!code || !hours || !mins || !secs || !apply) return;
        code.textContent = offer.code;
        apply.href = '/discount/' + encodeURIComponent(offer.code) + '?redirect=' + encodeURIComponent(location.pathname);
        apply.hidden = false;
        const offset = serverTime - Date.now();
        let interval;
        const render = () => {
          const remaining = Math.max(0, expiresAt - (Date.now() + offset));
          if (!remaining) { root.hidden = true; clearInterval(interval); return; }
          const total = Math.ceil(remaining / 1000);
          hours.textContent = String(Math.floor(total / 3600)).padStart(2, '0');
          mins.textContent = String(Math.floor((total % 3600) / 60)).padStart(2, '0');
          secs.textContent = String(total % 60).padStart(2, '0');
        };
        root.hidden = false;
        render();
        interval = setInterval(render, 1000);
      }).catch(() => {});
  })();

  } catch(e) { console.error(e); }
})();
})();
